import React, { useState, useEffect } from "react";
import { PROMO_FEATURES_ENABLED } from "../config/promoConfig";

export const PromotionalBanner = () => {
  const [dynamicEnabled, setDynamicEnabled] = useState(null);
  const [animationKey, setAnimationKey] = useState(0); // Force re-render when animation changes
  const API_BASE_URL = process.env.REACT_APP_API_URL || 'https://yuccan.tech';

  // Fetch current state from API
  useEffect(() => {
    const fetchBannerState = async () => {
      try {
        const response = await fetch(`${API_BASE_URL}/api/static-config/promo`);
        const result = await response.json();
        if (result.success) {
          setDynamicEnabled(result.data.enabled);
        }
      } catch (err) {
        // If API fails, fall back to static config
        console.warn('Failed to fetch dynamic config, using static fallback');
      }
    };
    
    fetchBannerState();
    
    // Poll every 5 seconds to check for changes
    const interval = setInterval(fetchBannerState, 5000);
    return () => clearInterval(interval);
  }, [API_BASE_URL]);

  // Use dynamic state if available, otherwise fall back to static config
  const BANNER_ENABLED = dynamicEnabled !== null ? dynamicEnabled : PROMO_FEATURES_ENABLED;

  // Broadcast promo state changes to other components (like navbar)
  useEffect(() => {
    localStorage.setItem('promoEnabled', BANNER_ENABLED.toString());
    window.dispatchEvent(new CustomEvent('promoStateChange', { detail: { enabled: BANNER_ENABLED } }));
  }, [BANNER_ENABLED]);

  // Listen for banner animation changes
  useEffect(() => {
    const handleStorageChange = () => {
      // Force component re-render to pick up new animation settings
      setAnimationKey(prev => prev + 1);
      
      // Apply CSS variables from localStorage
      const savedDuration = localStorage.getItem('bannerScrollDuration');
      const savedPosition = localStorage.getItem('bannerStartPosition');
      
      if (savedDuration || savedPosition) {
        const root = document.documentElement;
        if (savedDuration) {
          root.style.setProperty('--banner-scroll-duration', `${savedDuration}s`);
        }
        if (savedPosition) {
          root.style.setProperty('--banner-start-position', `${savedPosition}%`);
        }
      }
    };

    // Listen for storage changes (when admin panel updates localStorage)
    window.addEventListener('storage', handleStorageChange);
    
    // Also listen for custom events from admin panel
    window.addEventListener('bannerAnimationChange', handleStorageChange);
    
    // Apply initial settings from localStorage
    handleStorageChange();
    
    return () => {
      window.removeEventListener('storage', handleStorageChange);
      window.removeEventListener('bannerAnimationChange', handleStorageChange);
    };
  }, []);

  const bannerItems = [
    {
      type: "multimedia",
      content: (
        <span>
          <img 
            src="/img/Logo_2x_TP.png" 
            alt="Logo" 
            style={{height: '20px', marginRight: '8px', verticalAlign: 'middle'}}
          />
          ⚡Check out our current Promos!!⚡
        </span>
      )
    },
    {
      type: "text",
      content: "          "
    },
    {
      type: "multimedia",
      content: (
        <span>
          🖥️ NZ$249 Linux Server Setup Fee!!! 50% OFF on Edge or Cloud (VPS or Dedicated) Linux server initial setup, basic tools & services installation, and security hardening (ends 31 March 2026); click for more info
        </span>
      )
    },
    {
      type: "multimedia",
      content: (
        <span>
          🚗 NZ$74.99 Device + NZ$9.99 for First Month of Vehicle Tracking!!! GUARANTEED SAVINGS on high quality quick connect OBD2 tracker + standard telematics, no wiring (ends when stocks are exhausted); click for more info
        </span>
      )
    },
    {
      type: "multimedia",
      content: (
        <span>
          🌐 NZ$199 React & Next.js Multi-section Website Landing Page Build + Hosting!!! 67% OFF on quick turnaround for modern single page multi-section website landing page build, plus deployment and free hosting for the first month (always valid for new clients); click for more info
        </span>
      )
    },
    {
      type: "text",
      content: "          "
    },
    {
      type: "multimedia", 
      content: (
        <span>
          ✅ Guaranteed quality products & satisfaction on money spent 😀 👍
          <strong style={{marginLeft: '10px', color: '#FFE082'}}> Call: +64 9 886 4638</strong>
        </span>
      )
    },
    {
      type: "multimedia", 
      content: (
        <span>
          💰 💳 Let us help you save on your Digital Transformation (DX) strategies 💲 💵
          <strong style={{marginLeft: '10px', color: '#FFE082'}}> Call: +64 9 886 4638</strong>
        </span>
      )
    },
    {
      type: "multimedia", 
      content: (
        <span>
          📱 🕿 📧 Contact us now to find out more
          <strong style={{marginLeft: '10px', color: '#FFE082'}}> Call: +64 9 886 4638</strong>
        </span>
      )
    }
  ];

  // If banner is disabled, return null (completely hidden)
  if (!BANNER_ENABLED) return null;

  const handleBannerClick = () => {
    const promosSection = document.getElementById('promos');
    if (promosSection) {
      // Calculate offset for fixed menu bar
      const menuBar = document.getElementById('menu');
      const menuHeight = menuBar ? menuBar.offsetHeight : 80; // fallback to 80px
      const promotionalBannerHeight = PROMO_FEATURES_ENABLED ? 50 : 0;
      const totalOffset = menuHeight + promotionalBannerHeight; // No extra spacing
      
      const targetPosition = promosSection.offsetTop - totalOffset;
      
      window.scrollTo({
        top: targetPosition,
        behavior: 'smooth'
      });
    }
  };

  return (
    <div className={`promotional-banner ${BANNER_ENABLED ? '' : 'banner-disabled'}`} onClick={handleBannerClick} style={{cursor: 'pointer'}}>
      <div className="banner-content">
        <div className="scrolling-wrapper">
          <div key={animationKey} className="scrolling-content">
            {bannerItems.map((item, index) => (
              <span key={index} className="banner-item">
                {item.content}
              </span>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};